/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_About_DescriptionInputs */

const en_meta_about_description = /** @type {(inputs: Meta_About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo is an AI automation and custom AI development studio in Latvia. We build AI systems that save time, find revenue and run whole processes for small businesses and growing companies.`)
};

const lv_meta_about_description = /** @type {(inputs: Meta_About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo izstrādā mākslīgā intelekta risinājumus un AI automatizāciju. Veidojam AI sistēmas, kas ietaupa laiku, atrod jaunus ienākumus un vada veselus procesus maziem un augošiem uzņēmumiem.`)
};

/**
* | output |
* | --- |
* | "Lindevo is an AI automation and custom AI development studio in Latvia. We build AI systems that save time, find revenue and run whole processes for small bu..." |
*
* @param {Meta_About_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_about_description = /** @type {((inputs?: Meta_About_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_About_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_about_description(inputs)
	return en_meta_about_description(inputs)
});